export const TRUNCATION_INDICATOR = '[truncated]... ';

export function truncateStringStart(
    value: string,
    maxLength: number,
    truncationIndicator = TRUNCATION_INDICATOR,
): string {
    if (value.length <= maxLength || maxLength < 1) {
        return value;
    }
    return truncationIndicator + value.slice(-maxLength + truncationIndicator.length);
}
